import {history} from 'client/history';

import {showGlobalModal} from '@albert-io/atomic';

import {LOG_IN_PAGE_BASE_PATH, storePostLoginRedirect} from 'lib/postLoginRedirect';

import LogInModal from './LogInModal.react';

export {LOG_IN_PAGE_BASE_PATH};

export function redirectToLoginPageFromLocation() {
  const {pathname, search} = history.getCurrentLocation();
  // Persist the deep link the user was bounced from so UserRedirectUtil can return
  // them to it after login.
  storePostLoginRedirect(`${pathname}${search ?? ''}`);
  // Re-replacing the login page with itself churns the router mid-transition (#185 fuel).
  if (pathname !== LOG_IN_PAGE_BASE_PATH) {
    history.replaceState(null, LOG_IN_PAGE_BASE_PATH);
  }
}

export function hardRedirectToLoginPage() {
  global.document.location = LOG_IN_PAGE_BASE_PATH;
}

export function showGlobalLoginModal() {
  showGlobalModal(LogInModal);
}
